import {IComponentOptions} from 'angular';
import TSKoerperschaft from '../../../models/TSKoerperschaft';

declare let require: any;
declare let angular: any;

export class KoerperschaftComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        model: '=',
        name: '@',
        angabe: '@'
    };
    template = require('./dv-koerperschaft.html');
    controller = DvKoerperschaftController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DvKoerperschaftController {

    model?: TSKoerperschaft;
    name: string;
    angabe: string;

    public getModel(): TSKoerperschaft | undefined {
        return this.model;
    }
}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-koerperschaft/dv-koerperschaft.ts